import React, { useState } from "react";

import confirmBox from "./confirmBox";
import { canAdminChangeFoodReady, setFoodReady } from "../Functionalities/foodReady";
import { showMessage } from "../Functionalities/Functions";

export default function FoodReadyControl({ order, foodReadyAt, onChange }) {
  const [saving, setSaving] = useState(false);
  const changeable = canAdminChangeFoodReady(order);
  const rider = order?.delivery_boy?.first_name;

  const save = async (ready) => {
    setSaving(true);
    try {
      onChange(await setFoodReady(order.id, ready));
      showMessage(ready ? "Marked food ready" : "Food ready removed", "success", "Food ready", "top", "top-right");
    } catch (error) {
      showMessage(error.message, "danger", "Food ready", "top", "top-right");
    } finally {
      setSaving(false);
    }
  };

  const confirm = (ready) =>
    confirmBox({
      title: ready ? "Mark food ready?" : "Undo food ready?",
      message: ready
        ? rider
          ? `${rider} will get a push that FDR${order.id} is packed.`
          : `No rider yet. The rider who accepts FDR${order.id} will see it.`
        : `FDR${order.id} will no longer show food ready.`,
      onYes: () => save(ready),
    });

  if (foodReadyAt) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <span className="badge badge-success">Food ready</span>
        {changeable && (
          <button type="button" className="btn btn-link btn-sm p-0 ml-2" disabled={saving} onClick={() => confirm(false)}>
            Undo
          </button>
        )}
      </div>
    );
  }
  if (!changeable) return null;
  return (
    <button type="button" className="btn btn-outline-success btn-sm" disabled={saving} onClick={() => confirm(true)}>
      Mark food ready
    </button>
  );
}
